import type { CurrentPlatform } from "@/partner/entities/platforms";

export function mapPlatformToFormValues(
  platform: CurrentPlatform | null | undefined
): Record<string, any> {
  if (!platform) {
    return {
      title: "",
      description: "",
      gaId: "",
      googleSiteVerification: "",
      customHTML: "",
      customHead: "",
      footer: {
        title: "",
        subtitle: "",
        social: [],
      },
      privacyPolicyUrl: "",
      termsOfServiceUrl: "",
      refundPolicyUrl: "",
      legalEntity: {
        name: "",
        address: "",
        registrationNumber: "",
        email: "",
        phone: "",
      },
      customTerms: [],
      languageId: null,
      acceptTermsOfServiceOnSignIn: false,
    };
  }

  return {
    title: platform.title || "",
    description: platform.description || "",
    gaId: platform.gaId || "",
    googleSiteVerification: platform.googleSiteVerification || "",
    customHTML: platform.customHTML || "",
    customHead: platform.customHead || "",
    footer: {
      title: platform.footer?.title || "",
      subtitle: platform.footer?.subtitle || "",
      social:
        platform.footer?.social?.map(({ type, link }) => ({ type, link })) ||
        [],
    },
    privacyPolicyUrl: platform.privacyPolicyUrl || "",
    termsOfServiceUrl: platform.termsOfServiceUrl || "",
    refundPolicyUrl: platform.refundPolicyUrl || "",
    legalEntity: {
      name: platform.legalEntity?.name || "",
      address: platform.legalEntity?.address || "",
      registrationNumber: platform.legalEntity?.registrationNumber || "",
      email: platform.legalEntity?.email || "",
      phone: platform.legalEntity?.phone || "",
    },
    customTerms:
      platform.customTerms?.map(({ label, url }) => ({ label, url })) || [],
    languageId: platform.languageId || null,
    acceptTermsOfServiceOnSignIn:
      platform.acceptTermsOfServiceOnSignIn || false,
  };
}
